var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code',{staticClass:"imd-sm-code"},[_c('xmp',{domProps:{"innerHTML":_vm._s(_vm.value)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }